
import Cookie from 'common/services/util/-RFC.Cookie';
import BaseRestService from './baseRestService';

const _serviceDependencies = ['$http', '$q', 'Util'];

/**
 * @ngdoc service
 * @name rest.services.DeviceLocationsRestService
 *
 * @description
 * This class contains methods used to retrieve/update information about devices
 * using http requests.
*/
export default class LogoutRestService extends BaseRestService {

    /**
     * @param  {any} $http
     * @param  {any} $q
     */
    constructor($http, $q, Util) {

        super($http, $q, Util);

    }

    /**
     * @ngdoc function
     * @name rest.services.DeviceLocationsRestService#getAllAsync
     * @methodOf rest.services.DeviceLocationsRestService
     * @function
     *
     * @description
     * Retrieves all devices.
     *
     * @returns {Promise} The promise of the call.
     */
    getAllAsync() {

        const refreshToken = Cookie.get(CWCONFIG.cookie.refreshToken);
        return super.getAllAsync(`logout/?refresh_token=${refreshToken}`);

    }

}

_serviceDependencies.push(LogoutRestService);

angular.module('rest.services')
    .service('LogoutRestService', _serviceDependencies);



// WEBPACK FOOTER //
// ./scripts/restServices/logoutRestService.js